import { render } from "./SwitchPolicyForm.vue?vue&type=template&id=ad0b80c2&scoped=true"
import script from "./SwitchPolicyForm.vue?vue&type=script&lang=js"
export * from "./SwitchPolicyForm.vue?vue&type=script&lang=js"

import "./SwitchPolicyForm.vue?vue&type=style&index=0&id=ad0b80c2&scoped=true&lang=css"

import exportComponent from "/opt/anthos/FBL_OTWS/OTWS_src5/otws-external-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad0b80c2"]])

export default __exports__